/*
 * Copyright (c), Onnorokom Web Services Ltd (OWSL) and/or its affiliates. All rights reserved.
 * OWSL PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
*/

const imgFilePath = require('../../../applicationProperties.json').imgFilePath;

// EMI Desktop
const modal = $('#js--emiModal');
const openButton = $('#js--emiDetailsButton');

// Open the modal
openButton.on('click', () => {
    modal.show();
});

// Handle close button
function handleClose(closeButton) {
    $(closeButton).on('click', function () {
        modal.hide();
    });
}

// Close modal when clicking outside of it
$(window).on('click', (event) => {
    if ($(event.target).is(modal)) {
        modal.hide();
    }
});

// open emi details 
$(document).ready(function () {
  const showBankDetails = $("#js--bank-info");
  const productPrice = $("#js--product-price").val();
  const price = parseInt(productPrice);
  const startEmiFrom = $("#js--emi-start-from");

  // Add event to close button
  const closeButton = $("#js--close-modal-on-cross-button");
  if (closeButton.length) {
      handleClose(closeButton);
  }

  if (startEmiFrom.length) {
      startEmiFrom.html(`<span>${((price + (price * 0.03)) / 3).toFixed(2)}</span>`);
  }
});

const bankNames = [
    { id: 1, bankName: "Al-Arafah Islami Bank", image: "AIBL.png"},
    { id: 2, bankName: "Islami Bank Bangladesh", image: "IBBD.png" },
    { id: 3, bankName: "Shahjalal Islami Bank", image: "SIBL.png"},
  ];
  
  const monthData = [
    {
      id: 1,
      months: [
        { time: "3", charge: 0.03 },
        { time: "6", charge: 0.045 },
        { time: "9", charge: 0.065 },
        { time: "12", charge: 0.085 },
        { time: "18", charge: 0.115 },
        { time: "24", charge: 0.155 },
        { time: "36", charge: 0.195 },
      ],
    },
    {
      id: 2,
      months: [
        { time: "3", charge: 0.03 },
        { time: "6", charge: 0.045 },
        { time: "9", charge: 0.065 },
        { time: "12", charge: 0.085 },
        { time: "18", charge: 0.115 },
        { time: "24", charge: 0.155 },
        { time: "36", charge: 0.195 },
      ],
    },
    {
      id: 3,
      months: [
        { time: "3", charge: 0.03 },
        { time: "6", charge: 0.045 },
        { time: "9", charge: 0.065 },
        { time: "12", charge: 0.085 },
      ],
    },
  ];

  $(document).ready(function () {
    showBank();
    showEMIData(1);
  
    $('#js--show-bank-name').on('click', '.bank-item', function () {
      const bankId = $(this).data('id');
      showEMIData(bankId);
    });

  });

  $(document).on("click", '.bank-item', function() {    
      $('.bank-item').removeClass('bank-active');
      $(this).addClass('bank-active');
  });
  
  
  function showBank() {
    const $showBankName = $('#js--show-bank-name');
  
    if ($showBankName.length) {
      bankNames.forEach((bank, index) => {
        const $bankInfo = $(`
          <div class="bank-item ${index == 0 ? 'bank-active' : ''}" data-id="${bank.id}">
            <img src="${imgFilePath}/bank-logo/${bank.image}" alt="bank logo" />
            <span class="bank-name">${bank.bankName}</span>
            <i class="ion-chevron-right emi-show-of-a-bank" style="display: none; align-self: flex-end;" ></i>
          </div>
        `);
        $showBankName.append($bankInfo);
      });
    }
  }
  
  
  function showEMIData(bankId) {
    const $emiBreakdown = $('#js--emi-breakdown');
    const selectedBankData = monthData.find((bank) => bank.id === parseInt(bankId));
    const productPrice = $('#js--product-price').val();
    const price = parseInt(productPrice);
  
    if (selectedBankData && $emiBreakdown.length) {
      $emiBreakdown.empty();
      $emiBreakdown.append(`<div class="emi-details">${bankNames[bankId - 1].bankName}</div>`);
      selectedBankData.months.forEach((month) => {
        const $monthInfo = $(`
            <div class="bank-info-container">
                <div class="bank-info-container-items" id="js--emi-details-menu-button">
                    <span> ${month.time} EMIs | Convenience Fee (${(month.charge * 100).toFixed(2)}%) ৳${((price + (price * month.charge)) / month.time).toFixed(2)}/Month</span>
                    <button >
                        <img class="js--menu-arrow-button" src="${imgFilePath}/modal-icons/under-menu-arrow.png" alt="icon" />
                    </button>
                </div>
                <div class="emi-details-menu">
                    <p>
                        <span>Price </span>
                        <span>${price}</span>
                    </p>
                    <p>
                        <span>Convenience Fee </span>
                        <span>${(price * month.charge).toFixed(2)}</span>
                    </p>
                    <div class="border"></div>
                    <p>
                        <span>Total Amount Payable</span>
                        <span>${(price + (price * month.charge)).toFixed(2)}</span>
                    </p>
                </div>
            </div>
        `);
        $emiBreakdown.append($monthInfo);
      });
    }
  }
  
  $(document).on('click', '#js--emi-details-menu-button', function (event) {
    event.stopPropagation();
    const emiDetailsButton = $(this).closest('.bank-info-container').find('.emi-details-menu');
    $('.emi-details-menu').not(emiDetailsButton).removeClass('show');
    $('#js--emi-details-menu-button img').attr('src', `${imgFilePath}/modal-icons/under-menu-arrow.png`);

    if (emiDetailsButton.hasClass('show')) {
      emiDetailsButton.removeClass('show');
      $(this).find('img').attr('src', `${imgFilePath}/modal-icons/under-menu-arrow.png`);
    } else {
      emiDetailsButton.addClass('show');
      $(this).find('img').attr('src', `${imgFilePath}/modal-icons/up-menu-arrow.png`);
    }
  });